import styled from '@emotion/styled';
import media from '@shared/mediaQuery';

const InsightsStyle = styled('div')`
  ${media.desktop} {
    padding-bottom: 99px;
  }
  .insight--picks-wrap {
    ${media.desktop} {
      border-top: 1px solid #e0e0e0;
      padding-top: 40px;
      margin-top: 40px;
    }
    ${media.mobile} {
      margin-top: 20px;
      border-bottom: 10px solid #f6f6f6;
    }
  }
  .insight--list-wrap {
    ${media.mobile} {
      padding: 0 20px;
    }
    ${media.desktop} {
      border-top: 1px solid #e0e0e0;
      padding-top: 60px;
    }
  }
  .insight {
    &--header {
      display: flex;
      justify-content: space-between;
    }
    &--title {
      font-size: 28px;
      width: 253px;
      span {
        font-family: 'Pretendard-Bold';
        color: #333333;
        font-size: 28px;
        &:after {
          content: '.';
          color: #ff5500;
        }
      }
    }
    &--description {
      font-size: 16px;
      color: #555555;
    }
  }
`;

export default InsightsStyle;
